import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ExitApi, NotificationInfo, NotificationGrdiInfo, SortParameters } from 'src/app/core/api.gen';
import { LoaderService } from '../../core/loader.service';

@Component({
  selector: 'eos-notification-grid',
  templateUrl: './notification-grid.component.html',
  styleUrls: ['./notification-grid.component.css']
})
export class NotificationGridComponent implements OnInit {

  @Input() public EmployeeID: number;
  data: NotificationGrdiInfo = new NotificationGrdiInfo();
  showModal: boolean;
  currentPage = 1;
  page: number;
  changeCount: number[] = [10, 15, 25];
  totalPages: number;
  userId: number;

  constructor(public modal: NgbActiveModal, private exitApi: ExitApi, private loader: LoaderService) {
    this.data.sortParams = new SortParameters();
    this.data.notificationGridList = [];
  }

  ngOnInit() {
    const user = JSON.parse(localStorage.getItem('user_info'));
    this.userId = (user.userId);
    this.data.sortParams.page = 1;
    this.data.sortParams.itemsPerPage = 10;
    this.data.sortParams.totalRecords = 0;
    this.getPendingNotification();
  }
  getPendingNotification() {
    this.loader.show();
    this.exitApi.getNotifications(this.userId, 'Exit', this.data.sortParams).subscribe(data => {
      this.loader.clear();
      this.data = data;
    });
  }

  pageChanged(event: any): void {
    this.data.sortParams.itemsPerPage = event.itemsPerPage;
    this.data.sortParams.page = event.page;
    this.exitApi.getNotifications(this.userId, 'Exit', this.data.sortParams).subscribe(log => {
      this.data = log;
    });

  }

  onSelectChanges() {
    this.getPendingNotification();
  }

  navigateAction(id: number, value: string) {
    this.loader.show();
    this.exitApi.markNotificationRead(id, this.userId).subscribe(data => {
      this.loader.clear();
      window.location.href = value;
    });
   
  }
}
